/* eslint-disable promise/prefer-await-to-then */
import { WARNING } from '@app/constants';
import { handleCatchError } from '@app/services';

import { getFollowingMonth } from '@pages/WorkSchedule/utils/getFollowingMonth';
import { getInfoByMonth } from '@pages/WorkSchedule/utils/getInfoByMonth';
import { getPreviousMonth } from '@pages/WorkSchedule/utils/getPreviousMonth';
import { moveUserToDay } from '@pages/WorkSchedule/utils/moveUserToDay';
import type { NWorkSchedule } from '@pages/WorkSchedule/WorkSchedule.types';

export const moveUserToNewMonth: NWorkSchedule.MoveUserToNewMonth = ({
  activeBranchId,
  initialSchedules,
  newMonthsArray,
  employees,
  currentMonth,
  renderedMonths,
  direction,
  isLastMonth = false,
  employeeId,
  setCurrentMonth,
  setMonthTitleLoader,
  setCellsContainerLoader,
  setRenderedMonths,
  setInitialSchedules,
  showNotification,
  extractWorkSchedules,
  setInitialRecords,
  getEmployeesWorkSchedulesByUserIds,
  getEmployeesRecordsOnDates,
}) => {
  if (!activeBranchId) {
    return;
  }

  const dateStart =
    direction === 'forward'
      ? getInfoByMonth(
          isLastMonth
            ? newMonthsArray[newMonthsArray.length - 1]
            : getFollowingMonth(currentMonth.startDate)
        ).dateS
      : getInfoByMonth(
          isLastMonth
            ? newMonthsArray[newMonthsArray.length - 1]
            : getPreviousMonth(currentMonth.startDate)
        ).dateS;

  const nextMonthTitle = getMonthTitleWithYear(dateStart);

  setRenderedMonths(newMonthsArray);
  setCurrentMonth({
    title: nextMonthTitle,
    startDate: dateStart,
  });

  setMonthTitleLoader(true);
  setCellsContainerLoader(true);

  getEmployeesWorkSchedulesByUserIds({
    ActiveBranchId: activeBranchId,
    branchId: activeBranchId,
    dateS: direction === 'forward' ? renderedMonths[0] : dateStart,
    dateE:
      direction === 'forward'
        ? getInfoByMonth(newMonthsArray[newMonthsArray.length - 1]).dateE
        : getInfoByMonth(renderedMonths[renderedMonths.length - 1]).dateE,
    data: employees.map(({ Id }: { Id: number }) => Id),
  })
    .unwrap()
    .then(async (employeeWorkSchedules) => {
      const employeeRecords = await getEmployeesRecordsOnDates({
        ActiveBranchId: activeBranchId,
        data: employeeId
          ? [employeeId]
          : employees.map(({ Id }: { Id: number }) => Id),
        dateS: direction === 'forward' ? renderedMonths[0] : dateStart,
        dateE:
          direction === 'forward'
            ? getInfoByMonth(newMonthsArray[newMonthsArray.length - 1]).dateE
            : getInfoByMonth(renderedMonths[renderedMonths.length - 1]).dateE,
      }).unwrap();

      setInitialSchedules([
        ...(initialSchedules || []),
        ...extractWorkSchedules(employeeWorkSchedules),
      ]);
      setInitialRecords(employeeRecords);

      moveUserToDay(dateStart);
    })
    .catch((error: unknown) =>
      showNotification(handleCatchError(error), WARNING)
    )
    .finally(() => {
      setMonthTitleLoader(false);
      setCellsContainerLoader(false);
    });
};

function getMonthTitleWithYear(date: string): string {
  const monthTitle = getInfoByMonth(date).title.toUpperCase();
  const currentYear = new Date().getFullYear();
  const year = new Date(date).getFullYear();

  if (year !== currentYear) {
    return `${monthTitle} ${year}`;
  }

  return monthTitle;
}
